export default "__VITE_ASSET__B93IZ1vP__"